import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { CustomNotificationService } from '../services/custom-notification.service';

import { catchError, map } from 'rxjs/operators';
import { ApiResult } from '../models/api-result.model';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    constructor(private notificationService: CustomNotificationService) {

    }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(httpRequest).pipe(map(httpResponse => {
            if (httpResponse instanceof HttpResponse) {
                var isWrappedResponse = this.extractErrorsAndNotify(httpResponse.body, false);
                if(isWrappedResponse) return httpResponse.clone({ body: httpResponse.body.result});
            }
            return httpResponse;
        }), catchError((errorResponse: HttpErrorResponse) => {
            let error = errorResponse.status === 403 ? "Unauthorized access." : this.getErrorObject(errorResponse.error);
            this.extractErrorsAndNotify(error, true);
            return throwError(errorResponse);
        }));
    }

    //Returns if is wrapped result or not
    extractErrorsAndNotify(body: ApiResult<any> | string, isError: boolean) : boolean {
        if(body && body.hasOwnProperty('isValid') && body.hasOwnProperty('isNotValid')) {
            var response = body as ApiResult<any>;
            if(response.isNotValid) {
                this.notificationService.warning(response.messages);
            }
            return true
        }
        else if(isError && body) {
            if(typeof(body) === "object") {
                if((<object>body).hasOwnProperty('message')){
                    this.notificationService.warning((<any>body).message)
                } else{
                    this.notificationService.warning("The application has encountered an unknown error");
                }
            }
            else{
                this.notificationService.warning(body as string); // it is possible we directly send errors without wrapping them
            }
        }
        return false;
    }

    private getErrorObject(error: any){
        if (typeof(error) === 'string'){
            try {
                return JSON.parse(error)
            } catch (e) {
                return error;
            }
        }

        return error;
    }
}